const SidebarTemplateIcon = ({ isOpen }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" 
        width={isOpen ? "20px" : "24px"}
        height={isOpen ? "20px" : "24px"}
        viewBox="0 0 24 24" fill="none" 
        stroke="currentColor" stroke-width="2" 
        stroke-linecap="round" stroke-linejoin="round" 
        class="lucide lucide-layout-template-icon lucide-layout-template">
        <rect width="18" height="7" x="3" y="3" rx="1"/>
        <rect width="9" height="7" x="3" y="14" rx="1"/>
        <rect width="5" height="7" x="16" y="14" rx="1"/>
    </svg>
  );
};

export default SidebarTemplateIcon;